export enum NotificationTypes {
    reminders = 'reminders',
    updates = 'updates',
}
